import { SvgIcon, SvgIconProps } from '@mui/material';

const NewspaperOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="NewspaperOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M18 16C18.5523 16 19 16.4477 19 17C19 17.5523 18.5523 18 18 18H10C9.44772 18 9 17.5523 9 17C9 16.4477 9.44772 16 10 16H18Z" />
      <path d="M18 12C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H18Z" />
      <path d="M12 6C12.5523 6 13 6.44772 13 7V9C13 9.55228 12.5523 10 12 10H10C9.44772 10 9 9.55228 9 9V7C9 6.44772 9.44772 6 10 6H12Z" />
      <path d="M18 8C18.5523 8 19 8.44772 19 9C19 9.55228 18.5523 10 18 10H16C15.4477 10 15 9.55228 15 9C15 8.44772 15.4477 8 16 8H18Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 2C22.1045 2.00006 23 2.89547 23 4V17C23 19.7614 20.7614 21.9999 18 22H4C2.34315 22 1 20.6569 1 19V8C1 6.89517 1.8959 6.00014 3 6H5V4C5 2.89543 5.89543 2 7 2H21ZM3 19C3 19.5523 3.44772 20 4 20C4.55228 20 5 19.5523 5 19V8H3V19ZM7 19C7 19.351 6.93694 19.6869 6.82617 20H18C19.6568 19.9999 21 18.6568 21 17V4H7V19Z"
      />
    </SvgIcon>
  );
};

export default NewspaperOutlined;
